/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Facebook24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Facebook 24">
      <path
        fill="#0E0E0E"
        d="m16.78 13.25.56-3.594h-3.56V7.312c0-1.015.48-1.953 2.08-1.953h1.64V2.273S16.02 2 14.62 2C11.7 2 9.78 3.758 9.78 6.883v2.773H6.5v3.594h3.28V22h4v-8.75h3Z"
        className="SVG"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Facebook24,
  md: Facebook24,
  lg: Facebook24,
  xl: Facebook24,
  xxl: Facebook24,
  xxxl: Facebook24,
};

export const FacebookIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'facebook-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
